import React, { FC, useEffect } from "react";
import { AppDispatch, RootState } from "../../../store/store";
import { useDispatch, useSelector } from "react-redux";
import { PREAUTH_MICROSERVICE } from "../../../utils/constants";
import PreAuthScreen from "./PreAuthScreen";
import { getPortalData, resetPortalData } from "../../../models/preAuthSlice";
import {
  dispatchHeritageOrHealthIndiaPortalData,
  resolveHeritageHealthIndiaClaimId,
} from "../../../utils/heritageHealthIndiaClaimId";
import { useParams } from "react-router-dom";
import { getBasicDetails } from "../../../models/patientSlice";

type PreAuthScreenContainerProps = {
  setUrlLink: CallableFunction;
  urlLink: string;
  setClaimId: CallableFunction;
  isScreen: string;
  setRegId: CallableFunction;
  visitStage: any;
  nextStage: any;
  setMoveToNext: CallableFunction;
  setRenderToTop: CallableFunction
};

const PreAuthScreenContainer: FC<PreAuthScreenContainerProps> = (props) => {
  const { patients, hospital, preAuth, auth } = useSelector(
    (state: RootState) => state
  );
  const dispatch = useDispatch<AppDispatch>();
  const { id } = useParams();

  useEffect(() => {
    if (id) {
      dispatch(getBasicDetails({ id: parseInt(id) }));
    }
  }, [id]);

  const portalName =
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName ===
      "MEDI ASSIST" ||
    patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName
      ?.toLowerCase()
      ?.includes("aditya birla")
      ? "IHX"
      : patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName;

  useEffect(() => {
    if (
      patients?.fetchBasicDetails?.casesResponse?.patientSchemeId &&
      patients?.fetchBasicDetails?.casesResponse?.patientId &&
      patients?.fetchBasicDetails?.casesResponse?.id &&
      !props?.urlLink
    ) {
      const hospitalId = patients?.fetchBasicDetails?.casesResponse?.healthCareId || hospital?.selectedHospital?.value;
      const patientId = patients?.fetchBasicDetails?.casesResponse?.patientId;
      const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
      const casePreAuthId = "3";
      const schemeId =
        patients?.fetchBasicDetails?.casesResponse?.patientSchemeId;
      const schemeName =
        patients?.fetchBasicDetails?.casesResponse?.schemeMetaDataName;
      const templateCategory = "preAuth";
      const templateSubCategory = portalName;
      const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
      const isUpdate = "false";
      const token = auth?.accessToken;
      const data = false;

      // Validate mandatory fields for post
      const areFieldsValidPost = [
        hospitalId,
        patientId,
        caseId,
        schemeId,
        schemeName,
        templateSubCategory,
        visitId,
        token,
        isUpdate,
      ].every((field) => field);

      // Validate mandatory fields for patch
      const areFieldsValidPatch = [
        hospitalId,
        patientId,
        caseId,
        schemeId,
        schemeName,
        templateSubCategory,
        visitId,
        token,
        casePreAuthId,
      ].every((field) => field);

      if (data) {
        // call patch url
        if (areFieldsValidPatch && token) {
          const newUrlLink = `${
            PREAUTH_MICROSERVICE.API_MICROSERVICE
          }/template/patch?hospitalId=${hospitalId}&patientId=${patientId}&caseId=${caseId}&casePreAuthId=${casePreAuthId}&schemeId=${schemeId}&schemeName=${schemeName}&isUpdate=${isUpdate}&templateCategory=${templateCategory}&templateSubCategory=${templateSubCategory}&visitId=${visitId}&token=${encodeURIComponent(
            token
          )}`;

          props?.setUrlLink(newUrlLink);
        }
      } else {
        // call post url

        if (areFieldsValidPost && token) {
          const newUrlLink = `${
            PREAUTH_MICROSERVICE.API_MICROSERVICE
          }/template/post?hospitalId=${hospitalId}&patientId=${patientId}&caseId=${caseId}&schemeId=${schemeId}&schemeName=${schemeName}&isUpdate=${isUpdate}&templateCategory=${templateCategory}&templateSubCategory=${templateSubCategory}&visitId=${visitId}&token=${encodeURIComponent(
            token
          )}`;

          // const newUrlLink = `http://localhost:3000/template/post?hospitalId=${hospitalId}&patientId=${patientId}&caseId=${caseId}&schemeId=${schemeId}&schemeName=${schemeName}&isUpdate=${isUpdate}&templateCategory=${templateCategory}&templateSubCategory=${templateSubCategory}&visitId=${visitId}&token=${encodeURIComponent(
          //   token
          // )}`;
          props?.setUrlLink(newUrlLink);
        }
      }
    }
  }, [
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.patientSchemeId,
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.casesResponse?.healthCareId
  ]);

  useEffect(() => {
    const caseId = patients?.fetchBasicDetails?.casesResponse?.id;
    const visitId = patients?.fetchBasicDetails?.visitInfoResponse?.id;
    const casesResponse = patients?.fetchBasicDetails?.casesResponse;

    if (caseId && visitId) {
      const dispatched = dispatchHeritageOrHealthIndiaPortalData(
        dispatch,
        caseId,
        visitId,
        casesResponse,
      );
      if (!dispatched) {
        dispatch(getPortalData({ caseId, visitId }));
      }
    } else {
      dispatch(resetPortalData());
    }
  }, [
    patients?.fetchBasicDetails?.casesResponse?.id,
    patients?.fetchBasicDetails?.visitInfoResponse?.id,
  ]);

  useEffect(() => {
    if (preAuth?.portalData) {
      const {
        casePreAuthEchs,
        casePreAuthIhx,
        casePreAuthCghs,
        casePreAuthStarhealth,
      } = preAuth.portalData;

      if (casePreAuthEchs?.casePreAuthEchsReferralResponse) {
        props?.setClaimId(
          casePreAuthEchs.casePreAuthEchsReferralResponse.claimId || null
        );
      } else if (casePreAuthEchs?.casePreAuthEchsEmergencyResponse) {
        props?.setClaimId(
          casePreAuthEchs.casePreAuthEchsEmergencyResponse.claimId || null
        );
      } else if (casePreAuthIhx) {
        props?.setClaimId(casePreAuthIhx.claimId || null);
      } else if (casePreAuthCghs) {
        props?.setClaimId(casePreAuthCghs.claimId || null);
      } else if (casePreAuthStarhealth) {
        props?.setClaimId(casePreAuthStarhealth.claimId || null);
      } else {
        const heritageHealthIndiaClaimId = resolveHeritageHealthIndiaClaimId(
          preAuth.portalData,
        );
        props?.setClaimId(heritageHealthIndiaClaimId);
      }
    } else {
      props?.setClaimId(null);
    }
  }, [preAuth?.portalData]);
  return (
    <PreAuthScreen
      urlLink={props?.urlLink}
      setClaimId={props?.setClaimId}
      isScreen={props?.isScreen}
      setRegId={props?.setRegId}
      nextStage={props?.nextStage}
      setMoveToNext={props?.setMoveToNext}
      role={auth?.role?.role}
      setRenderToTop={props?.setRenderToTop}
    />
  );
};

export default PreAuthScreenContainer;
